import React from "react";
import { AccordionSummary } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ConfigSectionHeader = ({ title, valid }: { title: string; valid: boolean }) => (
    <AccordionSummary>
        <p>{title}</p>
        {valid ? <FontAwesomeIcon className="valid-icon" icon={["fas", "circle-check"]} /> : <FontAwesomeIcon className="invalid-icon" icon={["fas", "circle-xmark"]} />}
    </AccordionSummary>
);
